/**
 * @generated SignedSource<<edefefc45f88d00dd7dc56d3d0662c73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnlikeInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type UnlikeMutation$variables = {
  input: UnlikeInput;
};
export type UnlikeMutation$data = {
  readonly unlike: {
    readonly removedLikeId: string | null | undefined;
  } | null | undefined;
};
export type UnlikeMutation = {
  response: UnlikeMutation$data;
  variables: UnlikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnlikePayload",
    "kind": "LinkedField",
    "name": "unlike",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removedLikeId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlikeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlikeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3836ae797abbe56acbfc39513ee33849",
    "id": null,
    "metadata": {},
    "name": "UnlikeMutation",
    "operationKind": "mutation",
    "text": "mutation UnlikeMutation(\n  $input: UnlikeInput!\n) {\n  unlike(input: $input) {\n    removedLikeId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6f1d507d18b9e0bfb05da5e6cfd0005";

export default node;
